<script lang="ts">
    
    import { derived } from "svelte/store";
    import type { Readable, Writable } from "svelte/store";
    import type { State } from "../../Model/State";

    type Store = State | Writable<any> | Readable<any>;

    export let state: Store | Store[];

    let value: Store;

    $: setupStore(state);

    function setupStore(store: Store | Store[]): void {
        if (Array.isArray(store)) {
            value = derived(store, values => values);
        } else {
            value = store;
        }
    }

</script>

<slot value={$value}>{$value}</slot>
